import { render, staticRenderFns } from "./VAppSelect.vue?vue&type=template&id=0ec8c84b"
import script from "./VAppSelect.vue?vue&type=script&lang=js"
export * from "./VAppSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports